import { isWeb } from 'tamagui'

export const isPublic = isWeb && window.location.pathname.startsWith('/public/')
